import { PreferencesContext } from "../../contexts/PreferencesContext";
import React, { Component } from 'react';
import TableEmptyState from '../ReusableComponents/TableEmptyState';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Redirect, Link } from 'react-router-dom';
import { logout } from '../../actions/AppActions';
import { connect } from 'react-redux';
import SweetAlert from 'react-bootstrap-sweetalert';

// unidades
import moment from 'moment';
import { URL } from '../../variables';
import ReactPaginate from 'react-paginate';
import Tooltip from 'react-tooltip';
import { MdDelete, MdModeEdit, MdSearch } from 'react-icons/md';
import { Pagination } from '@material-ui/lab';
import { CircularProgress } from '@material-ui/core';
import { FaListAlt } from 'react-icons/fa';
import Search from '../ReusableComponents/Search';
import { BsFillEyeFill } from "react-icons/bs";
import { Button } from "react-bootstrap";
import VerQuestionario from './VerQuestionario';

class Questionarios extends Component {static contextType = PreferencesContext;

  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      path: '/',
      loading_screen: false,
      questionarios: [],
      pagination: {
        page: 1,
        last_page: 1
      },
      msgErro: '',
      show_warning: false,
      show_erro: false,
      unidade_to_delete: '',
      search: '',
      loading_search: true,
      showModal: false,
      questionarioSelect: []
    };
  }






  componentDidMount() {

    this.get_questionarios(this.state.pagination.page);
  }

  get_questionarios(page, search = '', busca = true) {
    if (busca == true) {
      if (this.state.loading_search == false) {
        this.setState({ loading_search: true });
      }
    } else
    if (this.state.loading_screen === false) {
      this.setState({ loading_screen: true });
    }
    fetch(`${URL}api/faculdade/get_questionarios?page=${page}&search=${search}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${this.props.token}`
        // 'Content-Type': 'application/json',
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token');localStorage.removeItem('user');
          this.props.logout();
          return;
        }
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
            erro += errors[i] + '\n';else

            erro += errors[i];
          }
          console.log(erro);
          this.setState({ redirect: true });
        } else
        {
          this.setState({ loading_search: false, questionarios: resp.questionarios, loading_screen: false, pagination: resp.pagination });
        }
      } catch (err) {
        this.setState({ redirect: true });
        console.log(err);
      }

    }).
    catch((err) => {
      this.setState({ redirect: true });

      console.log(err);
      // this.props.mudarLoadingHome(false);
    });
  }


  delete_questionario(id) {

    fetch(`${URL}api/faculdade/delete_questionario/${id}`, {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${this.props.token}`
        // 'Content-Type': 'application/json',
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token');localStorage.removeItem('user');
          // this.setState({redirect:true,path:'/'});
          this.props.logout();
          return;
        }
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
            erro += errors[i] + '\n';else

            erro += errors[i];
          }
          console.log(erro);
          this.setState({ msgErro: erro, show_warning: false, show_erro: true });
        } else
        {
          this.setState({ show_warning: false });
          this.get_questionarios(this.state.pagination.page, this.state.search);
        }




      } catch (err) {
        this.setState({ redirect: true });
        console.log(err);


      }

    }).
    catch((err) => {
      this.setState({ redirect: true });

      console.log(err);
    });
  }







  render() {
    return (
      <div className="row">
                {this.state.redirect == true && <Redirect to={this.state.path} />}

                <div className="col-12">
                    <div className="card">
                        <div className="card-body" id="card">

                            <h4 className="mt-0 header-title" style={{ fontSize: '1.5rem', color: 'black' }}>{this.context.t("legacy_lista_de_questionarios")}</h4>
                            <p style={{ fontSize: '1rem', color: 'black' }}>{this.context.t("legacy_aqui_sao_listados_todos_os_seus_questionarios")}</p>
                            <br />
                            <br />

                            <div className="row">

                                <div className="col-12">


                                    {/* <hr /> */}
                                    {this.state.loading_screen == false && <div>

                                        {/* <h4 className="mt-0 header-title" style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}>Questões</h4> */}
                                        {/* <br /> */}

                                        <div className="flex jcsb flex-wrap mb-4">

                                            <Search placeholder={this.context.t("legacy_pesquisar_pelo_nome_do_questionario")} ValueChange={(value) => {
                        clearTimeout(this.pesquisarTimeout);
                        this.pesquisarTimeout = setTimeout(() => {
                          let page = { ...this.state.pagination };
                          page.current_page = 1;
                          this.setState({ pagination: page, search: value, loading_search: true });
                          this.get_questionarios(1, value);
                        }, 500);
                      }} />


                                            <Link to={{
                        pathname: "/questionarios/register/"
                        // state: {
                        //     course_id: id
                        // }
                      }} style={{ textDecoration: "none" }}>
                                                <Button variant="success" className="flex align-center jcc"><FaListAlt style={{ marginRight: 10 }} /> <p style={{ margin: 0 }}>{this.context.t("legacy_adicionar_questionario")}</p></Button>
                                            </Link>
                                        </div>

                                        <div className="table-modern-card">
                                            <div className="table-modern-scroll mb-0">
                                                <table id="tech-companies-1" className="table table-striped">
                                                    <thead>
                                                        <tr>

                                                            <th>{this.context.t("label_name")}</th>
                                                            <th>{this.context.t("legacy_numero_de_questoes")}</th>
                                                            {<th>{this.context.t("label_registered_by")}</th>}


                                                            <th data-priority="3">{this.context.t("label_actions")}</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.loading_search == false && this.state.questionarios.map((item, id) =>

                            <tr key={id}>
                                                                <td>{item.name}</td>
                                                                <td>{item.questoes.length}</td>
                                                                {/* <td>Questão {id + 1}</td> */}
                                                                {<td>{item.owner.name}</td>}

                                                                <td>
  <div className="actions-group">

                                                                    <span
                                  onClick={() => {
                                    this.setState({ questionarioSelect: { ...item }, showModal: true });
                                  }}
                                  className="inline-flex align-center jcc bg-warning icon"
                                  style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                                  title={this.context.t("ui_gerenciar_questionario_4cf424e3")}>

                                                                        <BsFillEyeFill size={17} color="white" />
                                                                    </span>

                                                                    <Link to={`/questionarios/edit/${item.id}`} onClick={(e) => e.stopPropagation()}>
                                                                        <span
                                    className="inline-flex align-center jcc bg-info icon"
                                    style={{ width: "2em", height: "2em", borderRadius: "7px", marginRight: "2px", marginLeft: "2px" }}
                                    data-toggle="tooltip"
                                    title={this.context.t("legacy_editar_questionario_2")}>

                                                                            <MdModeEdit color="white" size={17} />
                                                                        </span>
                                                                    </Link>
                                                                    <span
                                  onClick={(e) => {
                                    this.questao_id = item.id;
                                    this.setState({ show_warning: true });
                                  }}
                                  className="inline-flex align-center jcc bg-danger icon"
                                  style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                                  title={this.context.t("ui_deletar_questionario_44d0f59c")}>

                                                                        <MdDelete size={17} color="white" />
                                                                    </span>

  </div>
</td>

                                                            </tr>
                            )}

                                                    </tbody>
                                                </table>

                                            </div>
                                        </div>
                                        <VerQuestionario showModal={this.state.showModal} setShowModal={(e) => this.setState({ showModal: e })} questionario={this.state.questionarioSelect} />

                                        {this.state.loading_search == true &&

                    <div className="row" style={{ margin: 0 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                                                <CircularProgress />
                                            </div></div>

                    }
                                        {this.state.loading_search == false && this.state.questionarios.length == 0 && <div className="row">
                                            <div className="col-12">
                                                <TableEmptyState title={this.context.t("legacy_nenhum_questionario_cadastrado")} icon="❓" />

                                            </div>
                                        </div>}

                                        <Pagination
                      className={this.state.pagination.last_page == 1 ? "hide" : ""}
                      style={{ display: "flex", justifyContent: "flex-end" }}
                      count={this.state.pagination.last_page}
                      value={this.state.pagination.current_page}
                      onChange={(_, value) => {
                        console.log(_, value);
                        let page = { ...this.state.pagination };
                        page.current_page = value;
                        this.setState({ pagination: page });
                        this.get_questionarios(value, this.state.search);
                      }} />


                                        {/* {this.state.andamento == true && <AvaliacaoAndamento get_processo={this.get_processo.bind(this)} {...this.props} />} */}

                                    </div>}

                                    {this.state.loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                                        {/* <div className="spinner-border text-primary" role="status"  >
                        </div> */}
                                        <CircularProgress />
                                    </div></div>}

                                    <SweetAlert
                    warning
                    title={this.context.t("legacy_atencao")}
                    onConfirm={() => {
                      this.setState({ show_warning: false, loading_search: true });
                      this.delete_questionario(this.questao_id);
                      // this.delete_banner(this.state.banner_to_delete);
                    }}
                    onCancel={() => {
                      this.setState({ show_warning: false });
                    }}
                    show={this.state.show_warning}
                    confirmBtnText={this.context.t("legacy_sim_desejo_apagar")}
                    cancelBtnText={this.context.t("legacy_cancelar")}
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="danger"
                    showCancel={true}>{this.context.t("ui_ao_deletar_este_questionario_ela_nao_estara_mais_d_523483a1")}


                  </SweetAlert>


                                </div>

                            </div>

                        </div>

                    </div>
                </div>
            </div>);

  }


}
const mapsStateToProps = (state) => (
{
  user: state.AppReducer.user,
  token: state.AppReducer.token
});


export default connect(mapsStateToProps, { logout })(Questionarios);